<template>

    <vue-plyr ref="plyr" :options="playerOptions">

      <video :poster="'/build/assets/support_video_thumb.jpg?v=12054549198'">
        <source src="https://player.vimeo.com/progressive_redirect/playback/747303698/rendition/360p/file.mp4?loc=external&signature=c193e64ec50c90587288b060af28bed37998bcb4f1eae4c03dc717c945f733c1" type="video/mp4" size="360">
        <source src="https://player.vimeo.com/progressive_redirect/playback/747303698/rendition/720p/file.mp4?loc=external&signature=e3cb0efb5e11c8da7d608021fbd45666095dabfdc2b72ca916a9af042585d97e" type="video/mp4" size="720">
        <source src="https://player.vimeo.com/progressive_redirect/playback/747303698/rendition/1080p/file.mp4?loc=external&signature=d8f216ddd8aac35263a51636f1a2cfd3f3f7fe8c48e26e580d3e16f4cf88801b" type="video/mp4" size="1080">
      </video>

    </vue-plyr>

</template>

<script>

export default {
    data(){
        return {
        	trial_thumb: '/build/assets/trial_video_tutorial_thumb.jpg',
        	premium_thumb: '/build/assets/premium_video_tutorial_thumb.jpg',
            playerOptions: {
                controls: [
                	'play-large',
                    'play',
                    'progress',
                    'volume',
                    'fullscreen',
                    'settings'
                ],
                settings: [
                    'quality'
                ],
                quality: {
                    'default': 1080
                },
                storage: {
                    'enabled': false
                }
            },
        }
    }
}

</script>
